export const SET_JOB = "setJob";

export const setJob = (payload: any) => {
  return {
    type: SET_JOB,
    payload,
  };
};
